/*
 * @Author: 邓宇芩 707208431@qq.com
 * @Date: 2025-08-05 10:54:29
 * @LastEditors: 邓宇芩 707208431@qq.com
 * @LastEditTime: 2025-11-12 15:48:53
 * @FilePath: \scanqrcode\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
// import Qrcode from '../views/Qrcode.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Qrcode',
  //   component: Qrcode
  // },
  {
    path: '/:name/:urlKey',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Home.vue')
  },
  {
    path: '/index/',
    name: 'index',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/qrcode',
    name: 'Reader',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Reader.vue')
  }
]

const router = new VueRouter({
  mode: 'hash', // history
  base: process.env.BASE_URL,
  routes
})

export default router
